import type { OptimizelyDecision } from '@optimizely/optimizely-sdk';

export type OptimizelyAllDecision = Record<string, OptimizelyDecision>;

type State = { initialDecisions?: OptimizelyAllDecision };

type OptimizelyFactoryArgs = {
  isServer: boolean;
  query: any;
  optimizely?: State;
};

type SetOptimizelyDecisionsAction = {
  type: typeof SET_INITIAL_DECISIONS;
  payload: OptimizelyAllDecision;
};

export const SET_INITIAL_DECISIONS =
  'CAT/NEXT/OPTIMIZELY/SET_INITIAL_DECISIONS';

const optimizelyFactory = ({
  isServer,
  optimizely = {},
}: OptimizelyFactoryArgs) => {
  const initialState = isServer ? optimizely : {};

  return (
    state: State = initialState,
    { type, payload }: SetOptimizelyDecisionsAction,
  ) => {
    if (type === SET_INITIAL_DECISIONS) {
      return { ...state, initialDecisions: payload };
    }

    return state;
  };
};

export default optimizelyFactory;
